import mitt, { Emitter } from 'mitt';

type MittInstance = Emitter<{
  OPEN_EASTER_RAFFLE: void;
  GOT_EASTER_EGG_CODE: void;
  REFRESH_CART_TRIGGER_ITEM_COUNT: void;
  OPEN_EASTER_10TH_RAFFLE: void;
  OPEN_SERVER_NAVIGATE_LOADING: void;
  REFRESH_CURRENT_USER_INFO: void;
  /** 接口被 CDN 拦截或服务不可用时触发，由 NetworkErrorToast 统一提示用户刷新 */
  NETWORK_ERROR: { statusCode?: number };
}>;

export const mittInstance: MittInstance = mitt();
